export function concatUrl(url) {
  let baseUrl = ''
  if (process.env.NODE_ENV === 'development') {
    require('../config')
    // baseUrl = window.baseUrl2
    baseUrl = '/crmApis'
  } else if (process.env.NODE_ENV === 'production') {
    let host = window.location.host
    // baseUrl = 'https://' + host + '/'
    if(host === 'surveytest.gyasset.com'){
      baseUrl = window.baseUrl1
    } else if(host === 'resulttest.gyasset.com') {
      baseUrl = window.baseUrl2
    }else if(host === 'survey.gyasset.com') {
      baseUrl = window.baseUrlPro1
    }else if(host === 'result.gyasset.com') {
      baseUrl = window.baseUrlPro2
    } else {
      baseUrl = `${window.location.protocol}/${window.location.host}/question`
    }
  } else {
    baseUrl = `${window.location.protocol}/${window.location.host}/question`
  }
  let bul = baseUrl
  if (baseUrl.endsWith('/')) {
    bul = bul.substring(0, bul.length - 1)
  }
  if (url.startsWith('/')) {
    return bul + url
  } else {
    return bul + '/' + url
  }
}
